import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonService, DocumentsService } from '../../../../../services/common';
import { SalesService } from '../../../sales.service';
import { environment } from '../../../../../../environments/environment';
import { IconList } from '../../../../../../iconlist';
import { AmountSubType, DocumentSubType } from '../../../../../../appconfig';
import { Router } from '@angular/router';
import { Guid } from 'guid-typescript';
import { ToasterService } from '../../../../../services/common/toaster.service';
declare const $: any;

@Component({
  selector: 'app-receipt-refund-add',
  templateUrl: './receipt-refund-add.component.html',
  styleUrl: './receipt-refund-add.component.scss'
})
export class ReceiptRefundAddComponent {
  @Input() currentReceipt: any;
  @Output() changeModalStatus = new EventEmitter<any>();
  date: Date | undefined;
  paymentForm!: FormGroup
  paymentEntity: any;
  paymentEntityDetails: any;

  Submitted = false;
  isSubmitButtonDisabled = false;

  banksID: any;
  paymentTypeCopy: any;
  paymentTypeCopyImg: any;
  BankN = false;
  showclickedPic!: boolean;
  selectedReceiptDate: any = null;
  selectedChequeDate: any;
  chequeDetail = false;
  picViewTitle: any = '';
  imgUrl: any;
  isReadOnly = true;
  showOverlay = false;
  bankList: any;
  projectBankList: any;
  showClient: boolean = false;
  paymentModeList: any;
  bankNameMandatory: any;
  displayDocumentFileDialogue: boolean = false;
  documentFileData: any;
  assetsImagePath = environment.assetsImagePath
  paymentAddUpdateIcon: any = this.assetsImagePath + IconList.AddIcon
  userProfilePicRecordExists: boolean = false
  paymentImage: any = environment.assetsImagePath + IconList.DefaultUserProfilePic
  displayDocumentPicDialogue: boolean = false;
  uploadedFile: any;
  isCash = true;
  maxDate!: Date;
  picViewData: any;
  selectedClient: any;

  bankIcon: any = environment.assetsImagePath + IconList.groupHome
  displayClientBankAcModal: boolean = false;
  /**
   * Bank data Common Module through CustomerList Component
   */
  columns: any = [
    { field: "selection", columnType: 'radio' },
    { headerName: "Bank Name", field: "bankName", cellStyle: { textAlign: 'left' } },
  ];
  fileName = '';

  /**
   * Client data Common Module through CustomerList Component
   */
  clientColumns: any[] = [
    { field: 'selection', columnType: 'radio' },
    { header: "Id", field: "id", columnType: 'text' },
    { header: "Allocation Type", field: "allocationType", columnType: 'text' },
    { header: "Unit Category", field: "product", columnType: 'text' },
    { header: "Received Amount", field: "recivedAmount", columnType: 'text' },
    { header: "Date Of Booking", field: "bookingDate", columnType: 'date' },
  ];

  clientBankAcColumns: any[] = [
    { field: "selection", columnType: 'radio' },
    { headerName: "Account Holder Name", field: "accountHolderName", cellStyle: { textAlign: 'left' } },
    { headerName: "Bank Account #", field: "bankAccountNo", cellStyle: { textAlign: 'left' } },
    { headerName: "IFSC Code", field: "ifsc", cellStyle: { textAlign: 'left' } },
    // { headerName: "Bank Name", field: "bank.bankName", cellStyle: { textAlign: 'left' } },
    { headerName: "Branch Name", field: "branchName", cellStyle: { textAlign: 'left' } },
  ];

  clientcolumnKeys: any[] = ['customerName', 'product', 'sourceName', 'amount', 'contactNumber'];
  clientList: any;
  bookingAllotmentList: any;
  //customerList: any;
  PaidByList: any;

  constructor(private formBuilder: FormBuilder, private toasterService: ToasterService, private commonService: CommonService,
    public saleservice: SalesService, public route: Router, private documentsService: DocumentsService
  ) {
    this.maxDate = new Date();
  }

  ngOnInit() {
    this.selectedReceiptDate = this.currentReceipt?.currentRecord?.paymentDate != undefined ? new Date(this.currentReceipt?.currentRecord?.paymentDate) : null;
    this.selectedChequeDate = this.currentReceipt?.currentRecord?.valueDate != undefined ? new Date(this.currentReceipt?.currentRecord?.valueDate) : null;
    this.fileName = 'Receipt ' + this.commonService.getCurrentTimeStamp();
    this.initiateReceiptForm();
    this.bankList = this.currentReceipt?.bankList;
    this.PaidByList = this.currentReceipt?.collectedByList;
    this.clientList = this.currentReceipt?.clientList;
    this.selectedClient = this.clientList.find((x: any) => x.id === this.paymentForm.value.clientId);
    this.projectBankList = this.currentReceipt?.projectBankList;
    if (this.currentReceipt?.paymentModeList) {
      this.paymentModeList = this.currentReceipt?.paymentModeList;
      this.ReceiptMode(true)
    }
    this.setDefaultUserProilePic();
  }

  /**
   * Payment Form Controls Key
   */
  initiateReceiptForm() {
    const ReceiptObject = this.currentReceipt?.currentRecord;
    const paymentModeId = ReceiptObject?.paymentModeDetail?.id;
    this.paymentForm = this.formBuilder.group(
      {
        id: [ReceiptObject?.id],
        paymentType: [ReceiptObject?.paymentType, [Validators.required]],
        isRecon: [ReceiptObject?.isRecon],
        reconDate: [ReceiptObject?.reconDate],
        dmid: [ReceiptObject?.dmid],
        paymentModeId: [paymentModeId == undefined ? "" : paymentModeId, [Validators.required]],
        bookingId: [ReceiptObject?.bookingId],
        allotmentId: [ReceiptObject?.allotmentId],
        collectedBy: [ReceiptObject?.collectedBy == undefined ? "" : ReceiptObject?.collectedBy, [Validators.required]],
        clientId: [ReceiptObject?.clientDetail?.id == undefined ? "" : ReceiptObject?.clientDetail?.id, [Validators.required]],
        amount: [ReceiptObject?.amount.replaceAll(/\,/g, ''), [Validators.required]],
        paymentDate: [new Date(ReceiptObject?.paymentDate), [Validators.required]],
        transactionNumber: [ReceiptObject?.transactionNumber, [Validators.required]],
        remark: [ReceiptObject?.remark, [Validators.required]],
        paymentTypeCopy: [this.currentReceipt?.transactionPic],//Remove required validation after discussion with Hitesh Gupta
        corelationId: [ReceiptObject?.corelationId],
        chequeDate: [new Date(ReceiptObject?.valueDate)],
        projectBankId: [ReceiptObject?.clientBankId == undefined ? null : ReceiptObject?.clientBankId],
        projectBankAccountId: [ReceiptObject?.projectBankDetail?.id == undefined ? "" : ReceiptObject?.projectBankDetail?.id, [Validators.required]],
        paymentEntityDetails: [null],
        clientBankAc: [null],
        clientBankId: [ReceiptObject?.bankId == undefined ? null : ReceiptObject?.bankId],
        clientBankAccountId: [ReceiptObject?.clientBankAccountId == undefined ? null : ReceiptObject?.clientBankAccountId],
      }
    );
    if (ReceiptObject?.transactionPicExtn) {
      this.paymentImage = ReceiptObject?.transactionPicExtn;
      this.paymentAddUpdateIcon = environment.assetsImagePath + IconList.EditIcon;
      this.userProfilePicRecordExists = true;
    }
  }

  get f(): { [key: string]: AbstractControl } {
    return this.paymentForm.controls;
  }

  /**
* When user will select client name on payment model then it will get booking of selected client
* @param id
*/
  getClientBookings(id: any) {
    //get selected client details from client list
    this.selectedClient = this.clientList.find((x: any) => x.id === id);

    this.paymentForm.controls['bookingId'].setValue(null);
    this.paymentForm.controls['allotmentId'].setValue(null);

    if (this.commonService.isNullUndefined(id)) {
      this.setTransactionNumber();
      this.paymentForm.controls['transactionNumber'].setValue(null);
      return;
    }
    this.saleservice.getClientBookingAllotment(id).subscribe(res => {
      if (res) {
        if (res?.result?.length == 1) {
          if (res.result[0].allocationType == 'Allotment') {
            this.paymentForm.controls['allotmentId'].setValue(res.result[0].id);
          } else {
            this.paymentForm.controls['bookingId'].setValue(res.result[0].id);
          }
          this.setTransactionNumber();
        }
        this.bookingAllotmentList = res.result.map((data: any) => {
          data.product = data.unitCategoryDetail.name;
          return data;
        });
        if (this.bookingAllotmentList?.length > 1) {
          this.showClient = true
        } else {
          this.showClient = false;
        }
      }
      else {
        this.setTransactionNumber();
      }
    })
  }

  // ADD Payment Form Submit Control
  onSubmit(): void {
    this.Submitted = true;

    const formObject = this.paymentForm.value;

    if (this.paymentForm?.invalid) {
      return;
    }

    this.isSubmitButtonDisabled = true;

    const selectedProject = JSON.parse(this.commonService.getValueFromLocalStorage("selectedProject")!);
    const filterClient = this.clientList.find((x: any) => x.id === formObject.clientId);
    const data = this.paymentForm.value;

    // Generate transaction number for new payments
    if (data.id == null) {
      if (this.paymentForm.value.paymentType === "MIS") {
        delete data.bankId; // Remove bankId for MIS payments
      }
    } else if (this.paymentForm.value.paymentType === "Cheque") {
      this.paymentForm.value.bankId = data.bankId;
      this.paymentForm.value.instrumentDate = data.instrumentDate;
    }

    // Format dates
    const pDate = this.commonService.dateTimeFormate(formObject.paymentDate);
    const payment = this.paymentModeList.find((p: any) => p.id === this.paymentForm.value.paymentModeId);
    const valueDate = payment?.paymentModeName === "Cheque" ? this.commonService.dateTimeFormate(formObject.chequeDate) : pDate;

    // Generate correlation ID
    const correlationId = data?.id > 0 ? formObject.corelationId : Guid.create().toString();

    // Prepare document details if a file is uploaded
    let documentDetails = null;
    if (this.uploadedFile) {
      documentDetails = {
        isActive: true,
        correlationId: correlationId,
        isVerified: false,
        docType: this.uploadedFile.document.name.split('.').pop(),
        fileBase64: this.paymentImage,
        documentSubTypeId: DocumentSubType['PaymentReceiptsAllotment']
      };
    }

    // Prepare project and client objects
    const projectObject = {
      projectId: selectedProject?.id,
      bookingId: formObject?.bookingId == 0 ? null : formObject?.bookingId,
      allotmentId: formObject?.allotmentId == 0 ? null : formObject?.allotmentId,
      amountCorrelationId: correlationId,
      accountId: selectedProject?.accountId,
      bankAccountId: formObject?.projectBankAccountId,
      bankId: formObject?.projectBanktId,
      AmountValue: (formObject?.amount * -1),  // Negative amount for project
      paymentDate: pDate,
      paymentModeId: formObject?.paymentModeId,
      transactionNo: formObject?.transactionNumber,
      comments: formObject?.remark,
      transactionPicExtn: this.uploadedFile?.document?.name?.split('.').pop(),
      isActive: true,
      collectedBy: formObject?.collectedBy,
      valueDate: valueDate,
      amountSubTypeId: this.currentReceipt?.refundAmountSubType?.id,
    };

    const clientObject = {
      projectId: selectedProject?.id,
      bookingId: formObject.bookingId == 0 ? null : formObject.bookingId,
      allotmentId: formObject.allotmentId == 0 ? null : formObject.allotmentId,
      amountCorrelationId: correlationId,
      accountId: filterClient.accountId,
      bankAccountId: formObject?.clientBankAccountId,
      bankId: formObject.clientBankId,
      AmountValue: formObject.amount, // Positive amount for client as refund
      paymentDate: pDate,
      comments: formObject.remark,
      paymentModeId: formObject.paymentModeId,
      transactionNo: formObject.transactionNumber,
      transactionPicExtn: this.uploadedFile?.document?.name?.split('.').pop(),
      isActive: true,
      collectedBy: formObject.collectedBy,
      valueDate: valueDate,
      documentDetails: documentDetails,
      amountSubTypeId: this.currentReceipt?.refundAmountSubType?.id
    };

    const arrayOfObjects = [projectObject, clientObject];

    // Determine whether to update or create a payment
    const apiCall = data?.id > 0
      ? this.saleservice.updatePaymentData(arrayOfObjects, formObject.corelationId)
      : this.saleservice.postPaymentData(arrayOfObjects);

    apiCall.subscribe((res: any) => {
      this.Submitted = false;
      this.toasterService.showSuccess(`Payment ${data?.id > 0 ? 'updated' : 'added'} successfully`);
      this.changeModalState(true);
    });

    this.isSubmitButtonDisabled = false
  }

  changeModalState(isSubmitted: boolean = false) {
    this.changeModalStatus.emit({
      "showaddUpdateModal": false,
      "isSubmitted": isSubmitted
    })
  }

  /**
   *
  *@param {any} data setting values of Agent
  */
  clientValues(data: any) {
    if (data) {
      this.paymentForm.controls['clientId'].setValue(data.clientDetail?.id);
      if (data.allocationType == 'Allotment') {
        this.paymentForm.controls['allotmentId'].setValue(data.id);
      } else {
        this.paymentForm.controls['bookingId'].setValue(data.id);
      }
      this.paymentEntity = data
      this.setPaymentEntityDetails(data);
      this.showClient = false;
      this.setTransactionNumber();
    }
  }

  setPaymentEntityDetails(data: any) {
    this.paymentEntityDetails = data?.allocationType + ' ID - ' + data?.id + ', Size - ' + data?.product +
      '\nBooking Date - ' + this.commonService.dateTimeFormate(data?.bookingDate, true) + '\nReceived Amount - ' + this.commonService.formatIndianCurrency(data?.recivedAmount);
  }

  //Showing modal on click of add payment button
  AddButton() {
    this.paymentForm.reset();
    //this.paymentForm.controls['paymentDate'].setValue(new Date());
  }


  //to show/hide the customer bank name in case of Cheque
  toggleBank() {
    this.showOverlay = !this.showOverlay;
  }

  /**
   * Click Payment Mode By Value Set & Open Bank Name
   */
  ReceiptMode(isEdit: any = false) {
    let payment = this.paymentModeList.find((p: any) => p.id == this.paymentForm.value.paymentModeId);
    const paymentRecord = this.currentReceipt?.currentRecord;
    if (payment) {
      this.isCash = true;
      this.bankNameMandatory = payment?.bankNameMandatory;
      this.paymentForm.controls['paymentType'].setValue(payment?.paymentModeName);
      this.BankN = this.bankNameMandatory ? true : false;
      this.paymentImage = this.assetsImagePath + IconList.PaymentTransaction;
      this.paymentForm.controls['bankId'].setValidators(null); // Add required validator
      this.paymentForm.controls['bankId'].updateValueAndValidity(); // Recalculate the control's validity
      if (payment?.paymentModeName === "Cheque") {
        this.chequeDetail = true;
        $("#TranNO").removeAttr('disabled');
        this.paymentForm.controls['chequeDate'].setValidators(Validators.required); // Add required validator
        this.paymentForm.controls['chequeDate'].updateValueAndValidity(); // Recalculate the control's validity

        if (!isEdit) {
          this.paymentForm.controls['transactionNumber'].reset();
          this.paymentForm.controls['transactionNumber'].setValue(null);
          this.paymentForm.controls['chequeDate'].reset();
          this.paymentForm.controls['chequeDate'].setValue(null);
        }
        this.setRequiredValidatorBank();
        this.paymentImage = this.assetsImagePath + IconList.DefaultBankCheqPic
      }
      // Click Payment Mode NEFT & Open Bank Name
      else if (payment?.paymentModeName === "NEFT/RTGS/IMPS") {
        $("#TranNO").removeAttr('disabled');
        this.setRequiredValidatorBank();
        if (!isEdit) {
          this.paymentForm.controls['transactionNumber'].reset();
        }
        this.paymentImage = this.assetsImagePath + IconList.DefaultIMPSPic;
      }
      // Click Payment Mode PayTm & Hide Bank Name
      else if (payment?.paymentModeName === "PayTm") {
        this.chequeDetail = false
        $("#TranNO").removeAttr('disabled');
        if (!isEdit) {
          this.paymentForm.controls['transactionNumber'].reset();
        }
        this.paymentImage = this.assetsImagePath + IconList.PaymentTransaction;
      }
      // Click Payment Mode UPI & Open Bank Name
      else if (payment?.paymentModeName === "UPI") {
        this.chequeDetail = false
        $("#TranNO").removeAttr('disabled');
        if (!isEdit) {
          this.paymentForm.controls['transactionNumber'].reset();
        }
        this.setRequiredValidatorBank();
        this.paymentImage = this.assetsImagePath + IconList.DefaultUPIPic;
      }
      else if (payment?.paymentModeName === "Card Swipe") {
        this.chequeDetail = false
        $("#TranNO").attr('disabled', 'disabled');
        if (isEdit == false) {
          this.setTransactionNumber();
        }
        this.setRequiredValidatorBank();
        this.paymentImage = this.assetsImagePath + IconList.DefaultCardSwipePic;
      } else if (payment?.paymentModeName === "MIS") {
        this.chequeDetail = false
        this.isCash = false;
        $("#TranNO").attr('disabled', 'disabled');
        if (isEdit == false) {
          this.setTransactionNumber();
        }
      }
    }
    else {
      this.chequeDetail = false
    }
    if (paymentRecord?.transactionPicExtn != undefined || paymentRecord?.transactionPicExtn != null) {
      this.paymentImage = paymentRecord?.transactionPicExtn;
    }
  }

  setRequiredValidatorBank() {
    this.paymentForm.controls['bankId'].setValidators(Validators.required); // Add required validator
    this.paymentForm.controls['bankId'].updateValueAndValidity(); // Recalculate the control's validity
  }

  toggleClientBankAc(isDisplay: boolean = true) {
    if (isDisplay) {
      if (this.commonService.isNullUndefined(this.selectedClient)) {
        this.toasterService.showError("Please select client to proceed further");
        return
      }
    }
    this.displayClientBankAcModal = isDisplay;
  }

  SetClientBankAcValues(data: any) {
    if (data) {
      //set selected client bank account values to form controls
      this.paymentForm.controls['clientBankId'].setValue(data?.bank?.id);
      this.paymentForm.controls['clientBankAccountId'].setValue(data.id);
      this.paymentForm.controls['clientBankAc'].setValue(data?.bank.bankName + ' - ' + data?.bankAccountNo);
      this.displayClientBankAcModal = false;
    }
  }

  setTransactionNumber() {
    const formObject = this.paymentForm.value;
    if (formObject.bookingId || formObject.allotmentId) {
      let tranValue = formObject.bookingId == null ? formObject.allotmentId : formObject.bookingId;
      this.paymentForm.controls['transactionNumber'].setValue(null);
      if (formObject.paymentType === "Card Swipe") {
        this.paymentForm.controls['transactionNumber'].setValue("Crd-" + tranValue + '-' + this.commonService.getCurrentTimeStampClient());
      } else if (formObject.paymentType === "MIS") {
        this.paymentForm.controls['transactionNumber'].setValue("MIS-" + tranValue + '-' + this.commonService.getCurrentTimeStampClient());
      }
    }
    else {
      this.paymentForm.controls['transactionNumber'].reset();
    }
  }

  /**
  * Set values for bank which is in add and edit modal
  * @param {any} data
  */
  setValues(data: any) {
    if (data) {
      this.paymentForm.controls['bankId'].setValue(data[0].id);
      this.paymentForm.controls['bankName'].setValue(data[0].bankName);
      this.banksID = this.paymentForm.controls['bankId'].setValue(data[0].bankName);
      this.showOverlay = false;
    }
  }

  //to hide the overlayed component
  hideOverlay() {
    this.showOverlay = false;
  }

  //to hide the client data
  hideClient() {
    this.showClient = false;
  }

  hidePicViewModal() {
    this.showclickedPic = false;
  }
  /**
   *
   * @param event Bank List Input Click Key Press
   */
  _keyPress(event: any) {
    const pattern = /[a-z]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  /**
  * @param event Take Image Set Base 64
  */
  uploadImage(event: any) {
    let file = event.target.files[0]
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.imgUrl = reader.result
      this.paymentTypeCopy = this.imgUrl.split(',')[1];
      let data = this.imgUrl.split(',')[0];
      let data1 = data.split(';')[0];
      let data2 = data1.split(':')[1];
      let data3 = data2.split('/')[1];
      this.paymentTypeCopyImg = data3;
    }
  }


  /**
  * @param picTitle Camera Pic Title Set
  * @param picFor
  * @param index Camera Pic Value Indexing Multiple Show
  */
  setClickPicView(picTitle: any, picFor: any, index: number = -1) {
    if (this.currentReceipt?.currentRecord != undefined) {
      if (this.currentReceipt?.currentRecord?.transactionPicExtn != null || this.currentReceipt?.currentRecord?.transactionPicExtn != undefined) {
        this.documentsService.getDocumentBytesById(0, this.currentReceipt?.currentRecord?.corelationId).subscribe((response: any) => {
          this.paymentImage = response;
          this.showclickedPic = true;
          if (this.paymentImage != undefined) {
            this.picViewData = {
              "picTitle": picTitle,
              "picFor": picFor,
              "picFile": this.paymentImage,
              "fileType": this.commonService.getFileTypeFromBase64String(this.paymentImage)
            }
          }
        });
      }

    };

  }

  convertToBase64(byteArray: Uint8Array): string {
    // Convert byte array to a string
    let binaryString = '';
    byteArray.forEach(byte => {
      binaryString += String.fromCharCode(byte);
    });

    // Convert the binary string to Base64
    return btoa(binaryString);
  }
  currentFileBytes: any;


  /**
    * Click Close Model Form
    */
  closePaymentDialogue() {
    this.paymentForm.reset()
    this.changeModalStatus.emit({
      "showaddUpdateModal": false,
      "displayDocumentPicModal": false,
    });
  }

  /**
   *
   * @param receivedPicData Receives file from common document file control which is updated by user
   */
  ReceivePaymentFile(receivedPicData: any) {
    if (receivedPicData && receivedPicData?.documentFile) {
      this.paymentImage = this.currentReceipt?.transactionPic;
      this.paymentImage = receivedPicData?.documentFile?.documentByte
      this.paymentAddUpdateIcon = environment.assetsImagePath + IconList.EditIcon
      this.uploadedFile = receivedPicData?.documentFile;
    } else {
      this.paymentImage = this.assetsImagePath + IconList.PaymentTransaction
    }
    this.displayDocumentPicDialogue = false;
    this.displayDocumentFileDialogue = false;
  }

  /**
  * Sets config of current file to be uploaded. As common document-file component must know that current image is being
  * uploaded for which document sub type.
  * @param documentSubType "Sub Type of document for which file needs to be uploaded" (opptional)
  */
  setCurrentFileConfig(documentSubType: any) {
    if (this.documentFileData) {
      this.documentFileData.picFor = this.commonService.addSpaceInCamelCase(documentSubType),
        this.documentFileData.showDocumentNumber = false;

    } else {
      this.documentFileData = {
        'picFor': this.commonService.addSpaceInCamelCase(documentSubType),
        "documentSubTypeId": DocumentSubType[documentSubType],
        'operationMode': this.userProfilePicRecordExists ? 'edit' : 'add',
      }
    }
    this.displayDocumentFileDialogue = true
    this.documentFileData.documentNoHide = false
  }

  /**
   * Sets the default pics of user profile. Also, add icon by defalt for operation.
   */
  setDefaultUserProilePic() {
    this.paymentImage = this.assetsImagePath + IconList.PaymentTransaction

    if (this.userProfilePicRecordExists)
      this.paymentAddUpdateIcon = this.assetsImagePath + IconList.EditIcon
    else
      this.paymentAddUpdateIcon = this.assetsImagePath + IconList.AddIcon
  }
}
